import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the pack after purchasing?',
  a: 'You will receive immediate access to all the material so you can start using it right away, with no waiting and no complicated steps.'
}, {
  q: 'What educational level is it designed for?',
  a: 'Research Methods Ready™ is designed primarily for high school educators. It is also compatible with AP Research, IB Extended Essay, A-Levels, general secondary education, technical education and introductory college programs worldwide.'
}, {
  q: 'Does it work for teachers in any country?',
  a: 'Yes. The material is written in clear academic English and includes international adaptation notes. It works for teachers regardless of their school calendar, citation edition or institutional requirements.'
}, {
  q: 'Is the material editable?',
  a: 'The material is delivered in PDF format, professionally designed and print-ready.'
}, {
  q: 'What currency will I pay in?',
  a: 'You pay in your local currency. The amount adapts automatically based on the country you are purchasing from.'
}, {
  q: 'What if I do not like it?',
  a: 'You are fully covered by the 7-day money back guarantee. No questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}